import md5 from "blueimp-md5";
import request from "@/utils/request";
import { isProduction } from "@/utils";

/**
 * 用户手机登录接口
 */
export function login(data: any) {
  return request({
    url: "v1/user/auth/login",
    method: "post",
    data
  });
}

//banner列表
export function bannerList(params: any) {
  return request({
    url: "api/client/banner/all",
    method: "get",
    params: params
  });
}
//学员列表
export function studentList(params: any) {
  return request({
    url: "api/client/student/list",
    method: "get",
    params: params
  });
}

//活动列表
export function activityList(params: any) {
  return request({
    url: "api/client/activity/list",
    method: "get",
    params: params
  });
}

//活动详情
export function activityInfo(params: any) {
  return request({
    url: "api/client/activity/info",
    method: "get",
    params: params
  });
}
//项目详情
export function projectInfo(params: any) {
  return request({
    url: "api/client/project/info",
    method: "get",
    params: params
  });
}

//讲师详情
export function teacherInfo(params: any) {
  return request({
    url: "/api/client/teacher/info",
    method: "get",
    params: params
  });
}
// 问题列表
export function questionList(params: any) {
  return request({
    url: "api/client/qanda/list",
    method: "get",
    params: params
  });
}
// 课程预告
export function courseList(params: any) {
  return request({
    url: "api/client/course/open/notice",
    method: "get",
    params: params
  });
}
// 光华商学展示
export function collegeList(params: any) {
  return request({
    url: "api/client/course/college/view",
    method: "get",
    params: params
  });
}

// 咨询数记录
export function setCount(data: any) {
  return request({
    url: "api/client/util/consult_num",
    method: "post",
    params: data
  });
}

// 课程详情
export function openInfo(params: any) {
  return request({
    url: "/api/client/course/open/info",
    method: "get",
    params: params
  });
}

export function pblList(params: any) {
  return request({
    url: "https://test.eweixue.com/v1/pbl/list",
    method: "get",
    params: params
  });
}

// http://gttnbss.hztbc.com
function getLeadsBase() {
  if (isProduction()) {
    // return "http://gttnbss.hztbc.com";
    return "https://hztbc.steptowin.com";
  }
  return "https://test-gtt-api.eweixue.com";
}

export function addOpenLeads(data: any) {
  return request({
    url: `${getLeadsBase()}/msi/hztbc/add_open_leads.php`,
    method: "post",
    data
  });
}

// 图形验证码图片地址，需携带手机号参数 k，_t 用于防止浏览器缓存
export function getCaptchaUrl(tel: string) {
  return `${getLeadsBase()}/msi/hztbc/captcha.php?k=${encodeURIComponent(
    tel
  )}&_t=${+new Date()}`;
}

//首页案例
// http://hztbc.com/news/list_api.php?action=list&classid=39&platform=h5&_t=1762323510463&token=&page=1&per_page=12
export function newList(params: any) {
  return request({
    url: "https://hztbc.com/news/list_api.php",
    method: "get",
    params: params
  });
}

//https://api.eweixue.com/v1/organization/course/go_enroll?platform=h5&_t=1762394727482&token=&page=1&per_page=12
export function goEnroll(params: any) {
  return request({
    url: "https://api.eweixue.com/v1/organization/course/go_enroll",
    method: "get",
    params: params
  });
}

// http://hztbc.com/news/list_api.php?action=list&type=2&platform=h5&_t=1762323510463&token=&page=1&per_page=12
//讲师列表
export function teacherList(params: any) {
  return request({
    url: "https://hztbc.com/news/list_api.php",
    method: "get",
    params: params
  });
}
